import {Box, Button, createStyles, Dialog, Divider, makeStyles, TextField, Theme, withStyles} from "@material-ui/core";
import clsx from "clsx";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import {useState} from "react";
import UtilService from "../../../../../helper/service";
import ChipInput from 'material-ui-chip-input';

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '24px !important',
    overflow: 'hidden'
  },
  dialogDiv: {
    overflow: 'auto'
  },
  btn: {
    width: 80,
    height: 43,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 16,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  th: {
    backgroundColor: '#FFE9C4',
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 14,
    paddingRight: 14,
    fontFamily: 'roboto-bold',
    fontSize: 15,
    color: '#717E8B',
    borderRadius: '10px 10px 0px 0px'
  },
  td: {
    marginTop: 2,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 14,
    paddingRight: 14,
    background: '#F0F0F0',
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#717E8B',
  },
  icon: {
    marginLeft: 4,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  hidden: {
    display: 'none!important'
  },
  doneBtn: {
    margin: 0,
    padding: 0,
    height: 22,
    background: '#697683',
    borderRadius: 4,
    color: '#fff',
    fontSize: 8,
    marginLeft: 5,
    '&:hover': {
      background: '#343B43'
    }
  },
  ml: {
    right: -80
  },
  icons: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  textField: {
    "& .MuiOutlinedInput-inputMarginDense": {
      margin: "0!important",
      border: '1px solid #697683',
      padding: 4,
      borderRadius: 3,
      paddingLeft: 6,
      fontSize: 14,
      color: '#717E8B',
    }
  },
  invalid: {
    color: 'red'
  },
  hover: {
    cursor: 'pointer',
    width: 16,
    height: 16,
    marginLeft: 10
  },
  transForm: {
    transform: 'rotate(180deg)'
  },
  chip:{
    overflow: 'auto hidden',
    maxWidth: 400,
    chipContainer:{
      style:{flexFlow:'row'}
    }
  },
  sortColumn: {
    display: 'flex',
    alignItems: 'center',
    width: '60%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  hoverBtnGroup: {
    width: '30%'
  }
}));

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    header: {
      color: '#606B76',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7
    }
  });

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>{children}</div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon style={{ fontSize: 30 }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const CssChipInput = withStyles({
  chip:{
    height: 24,
    margin:"10px 5px 0px 0px"
  },
  input:{
    padding:0
  },
  chipContainer: {
   flexFlow:'row'
  },
})(ChipInput);

interface IProps {
  open: boolean;
  participants: any[];
  errorEmailIndex: number;
  onSaveParticipants: (newParticipants: any[]) => void;
  onClose: () => void
}

const ParticipantsModal = (props: IProps) => {
  const classes = useStyles();
  const { open, participants, onSaveParticipants, onClose, errorEmailIndex } = props;

  const [editIndex, setEditIndex] = useState(-1);
  const [initStepHover, setInitStepHover] = useState(-1);
  const [emailSort, setEmailSort] = useState(false);

  const removeParticipant = (index: number) => {
    const old = [...participants];
    old.splice(index, 1);
    onSaveParticipants(old);
  };

  const setOnChangeEmail = (e: any, index: number) => {
    const old = [...participants];
    old[index].email = e.target.value;
    onSaveParticipants(old);
  };

  const onCloseDialog = () => {
    onClose();
    setEditIndex(-1);
    setInitStepHover(-1);
  };

  const handleSort = () => {
    setEditIndex(-1);
    setEmailSort(!emailSort);
    const sortedData = emailSort ?
      participants.sort((a: any, b: any) => {
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      })
      :
      participants.sort((a: any, b: any) => {
        if (a < b) {
          return 1;
        }
        if (a > b) {
          return -1;
        }
        return 0;
      });
    onSaveParticipants(sortedData);
  };

  const onExtractTags = (tags: any[]) => {
    if (tags.length === 0) return '';
    return UtilService.getParsedTags(tags);
  }

  const onChipValue = (tags: any[]) => {
    if (tags.length === 0) return [];
    return tags.map((tag: any) => {
      return tag.tag_name;
    });
  }

  const onAddTag = (newTag: string, index: number) => {
    const currentParticipants = [...participants];
    const tags = currentParticipants[index].tags;
    const newTags = [...tags];
    const found = tags.find((tag: any) => tag.tag_name === newTag);
    !found && newTags.push({tag_name: newTag});
    currentParticipants[index].tags = newTags;
    onSaveParticipants(currentParticipants);
  };

  const onDeleteTag = (removeTag: string, index: number) => {
    const currentParticipants = [...participants];
    const tags = currentParticipants[index].tags;
    const newTags = tags.filter((tag: any) => tag.tag_name !== removeTag);
    currentParticipants[index].tags = newTags;
    onSaveParticipants(currentParticipants);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={'md'}
      onClose={onCloseDialog}
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <div className={classes.dialogDiv}>
        <DialogTitle onClose={onCloseDialog}>
          {participants.length} Participants Added
        </DialogTitle>
        <Divider />

        <Box m={4} pl={1} pr={1}>
          <th className={classes.th}>
            <td className={classes.sortColumn}>
              Email
              <img
                src='/assets/icons/experiencebuilder/filter-icon.svg'
                alt='{}'
                className={clsx(classes.hover, emailSort && classes.transForm)}
                onClick={() => handleSort()}
              />
            </td>
            <td className={classes.sortColumn}>
              Tags
            </td>
            <td className={classes.hoverBtnGroup} />
          </th>
          {
            participants.map((item: any, index: number) =>
              <tr
                className={classes.td}
                key={index}
                onMouseOver={() => (editIndex === index || editIndex === -1) && setInitStepHover(index)}
                onMouseLeave={() => setInitStepHover(-1)}
              >
                <td className={classes.sortColumn}>
                  {editIndex !== index ?
                    <p className={errorEmailIndex === index ? classes.invalid : ''}>{ item.email }</p>
                    :
                    <TextField
                      className={classes.textField}
                      value={item.email}
                      size="small"
                      variant="outlined"
                      onChange={(e) => setOnChangeEmail(e, index)}
                    />
                  }
                </td>
                <td className={classes.sortColumn}>
                  {editIndex !== index ?
                    <p className={errorEmailIndex === index ? classes.invalid : ''}>{onExtractTags(item.tags)}</p>
                    :
                    <CssChipInput
                      fullWidthInput={true}
                      value={onChipValue(item.tags)}
                      margin='normal'
                      id="sessions"
                      InputProps={{
                        style:{flexFlow: "initial"}
                      }}
                      className={classes.chip}
                      onAdd={(tag) => onAddTag(tag, index)}
                      newChipKeyCodes={[32, 188]}
                      newChipKeys={[]}
                      onDelete={(tag) => onDeleteTag(tag, index)}
                    />
                  }
               </td>
                <td  className={classes.hoverBtnGroup}>
                  {initStepHover !== index && <div style={{marginLeft: 56}} />}
                  <div className={clsx(classes.icons, initStepHover !== index && classes.hidden, editIndex !== index && classes.ml)}>
                    <img src={'/assets/icons/experiencebuilder/edit-icon.svg'} alt="{}" className={classes.icon} onClick={() => setEditIndex(index)} />
                    <img src={'/assets/icons/experiencebuilder/trash-icon.svg'} alt="{}" className={classes.icon} onClick={() => removeParticipant(index)} />
                    {editIndex === index && <Button className={classes.doneBtn} onClick={() => setEditIndex(-1)}>DONE</Button>}
                  </div>
                </td>
              </tr>
            )
          }
        </Box>
        <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
          <Button onClick={onCloseDialog} color='primary' size='large' className={classes.btn}>
            OK
          </Button>
        </Box>
      </div>
    </Dialog>
  )
};

export default ParticipantsModal;